import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface ProductMarketState {
  selectedCountry: string | undefined;
  setSelectedCountry: (country: string | undefined) => void;
}

export const useProductMarketStore = create<ProductMarketState>()(
  devtools(
    persist(
      (set) => ({
        selectedCountry: undefined,
        setSelectedCountry: (country) => set({ selectedCountry: country }),
      }),
      {
        name: 'product-market-storage',
      }
    )
  )
);
